import { DateTime } from 'luxon';

// One day in milliseconds.
export const DAY_MS = 24 * 60 * 60 * 1000;

// "(UTC+06:00) Dhaka" — live offset (DST-aware); falls back to originalLabel for an unknown zone.
export const getCurrentTimezoneLabel = (zoneName: string, originalLabel: string): string => {
  const now = DateTime.now().setZone(zoneName);
  if (!now.isValid) return originalLabel;

  const offset = now.toFormat('ZZ'); // -04:00 format
  const region = originalLabel.split(') ')[1] || zoneName.split('/')[1]?.replace(/_/g, ' ') || zoneName;

  return `(UTC${offset}) ${region}`;
};

export const formatTimestampFromSecond_nonLocal = (timestamp: number) => {
  if (!timestamp) {
    return '-';
  }
  const date = new Date(timestamp * 1000); // Convert timestamp to milliseconds
  const year = date.getUTCFullYear();
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = date.getUTCDate().toString().padStart(2, '0');
  const hours = date.getUTCHours().toString().padStart(2, '0');
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');
  const seconds = date.getUTCSeconds().toString().padStart(2, '0');

  return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
};

export const formatTimestampFromSecondWithoutComma_nonLocal = (timestamp: number) => {
  if (!timestamp) {
    return '-';
  }
  const date = new Date(timestamp * 1000); // Convert timestamp to milliseconds
  const year = date.getUTCFullYear();
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = date.getUTCDate().toString().padStart(2, '0');
  const hours = date.getUTCHours().toString().padStart(2, '0');
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');
  const seconds = date.getUTCSeconds().toString().padStart(2, '0');

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

export const formatTimestampFromSecond = (timestamp: number, timeZone: string = 'UTC') => {
  if (!timestamp) {
    return '-';
  }

  const date = new Date(timestamp * 1000);
  return new Intl.DateTimeFormat('en-GB', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).format(date);
};

export const formatTimestampFromSecondWithoutComma = (timestamp: number, timeZone: string = 'UTC') => {
  if (!timestamp) {
    return '-';
  }

  const date = new Date(timestamp * 1000);
  const dateParts = new Intl.DateTimeFormat('en-GB', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).formatToParts(date);

  const formattedDate = `${dateParts.find((part) => part.type === 'day')?.value}/${
    dateParts.find((part) => part.type === 'month')?.value
  }/${dateParts.find((part) => part.type === 'year')?.value} ${dateParts.find((part) => part.type === 'hour')?.value}:${
    dateParts.find((part) => part.type === 'minute')?.value
  }:${dateParts.find((part) => part.type === 'second')?.value}`;

  return formattedDate;
};

export const formatTimestampFromMilliSecond = (timestamp: number) => {
  if (!timestamp) {
    return '-';
  }
  const date = new Date(timestamp); // Convert timestamp to milliseconds
  const year = date.getUTCFullYear();
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = date.getUTCDate().toString().padStart(2, '0');
  const hours = date.getUTCHours().toString().padStart(2, '0');
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');
  const seconds = date.getUTCSeconds().toString().padStart(2, '0');

  return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
};

export const formatTimestampFromSecondMonthDayYear = (timestamp: number) => {
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  const date = new Date(timestamp * 1000); // Convert timestamp to milliseconds
  const monthIndex = date.getUTCMonth();
  const month = months[monthIndex];
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();

  return `${month} ${day}, ${year}`;
};

export const formatTradeDateTime = (seconds: number) => {
  if (!seconds) return '-';
  const date = new Date(seconds * 1000);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds_str = String(date.getSeconds()).padStart(2, '0');
  return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds_str}`;
};
